import { copyUsableValues } from '../../utils/UsableValues';
import { IReviewDetailsData } from './ReviewDetails';

export class ReviewProduct {
    public name: string;
    public image_url: string;
    public description: string;
    public category_name: string;
    public url: string;
    public manufacturer_id?: string;
    public price?: string;
    public upc?: string;
    public brand_name?: string;
    public in_stock?: boolean;

    public static toJson(data: IReviewDetailsData) {
        const reviewProduct = new ReviewProduct();
        const mappingData = {
            name: data.name,
            url: data.url,
            image_url: data.imageUrl,
            description: data.description,
            category_name: data.categoryName,
            manufacturer_id: data.manufacturerId,
            upc: data.upc,
            brand_name: data.brandName,
            price: data.price
        };
        copyUsableValues(mappingData, reviewProduct);

        return reviewProduct;
    }
}
